import { render } from "./FilterListKapal.vue?vue&type=template&id=6989d3a8"
import script from "./FilterListKapal.vue?vue&type=script&lang=js"
export * from "./FilterListKapal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__